var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-main"},[_c('home-header'),_c('div',{staticClass:"app-body"},[_c('section',[_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('keep-alive',{attrs:{"exclude":"Tools,EventConfig,AcquisitionEventManagement,EventConfigOld,AcquisitionEventManagementOld"}},[_c('router-view')],1)],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }